import type { ReactNode } from 'react';

import { Card } from '@playerbase/ui';

/*
 * AuthShell is the shared centred-card frame used by all auth and onboarding
 * pages. It places a PlayerBase wordmark above a constrained Card so every
 * auth surface is visually consistent without duplicating layout code.
 */

export interface AuthShellProps {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}

export function AuthShell({ title, subtitle, children }: AuthShellProps): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg px-4 py-12">
      {/* Wordmark */}
      <p className="mb-6 font-mono text-xs uppercase tracking-wider text-text-muted">
        PlayerBase
      </p>

      <div className="w-full max-w-md">
        <Card>
          <Card.Header>
            <Card.Title className="font-display text-2xl font-bold text-text">
              {title}
            </Card.Title>
            {subtitle !== undefined && (
              <Card.Description className="mt-1 text-sm text-text-muted">
                {subtitle}
              </Card.Description>
            )}
          </Card.Header>

          <Card.Content>{children}</Card.Content>
        </Card>
      </div>
    </div>
  );
}
